import { ReactElement } from 'react';
import { Route } from 'react-router-dom';
import { IRouteItem } from '@common/interfaces';

export function generateRouteElements(routeItems: IRouteItem[]): ReactElement[] {
  return routeItems.map(({ path, component }) => <Route key={path} path={path} element={component} />);
}
